import assign from 'object-assign';
import RestHelper from '../utils/RestHelper';

function savePipelineData(pipelineData, endpoint) {
  const params = {
    params: pipelineData
  };
  return RestHelper
    .post(endpoint, params);
}

export const loadDataInitiation = (dispatch, component) => {
  dispatch({
    type: 'INIT_PIPELINE_DATA',
    data: {
      component
    }
  });
};

export const dataRequest = (dispatch, state) => {
  dispatch({
    type: 'SUBMIT_PIPELINE_DATA',
    data: {
      values: state
    }
  });
};

export const dataRequestSuccess = (dispatch, response) => {
  dispatch({
    type: 'SUBMIT_SUCCESSFUL',
    data: {
      response: response.data
    }
  });
};

export const dataRequestError = (dispatch, error) => {
  dispatch({
    type: 'SUBMIT_ERROR',
    data: {
      error
    }
  });
};

export const submitData = (dispatch, data, submitEndpoint) => {
  const resp = savePipelineData(data, submitEndpoint);
  dataRequest(dispatch, data, submitEndpoint);
  return resp
    .then((response) => {
      dataRequestSuccess(dispatch, response);
    }).catch((err) => {
      dataRequestError(dispatch, err);
      console.error(err); // eslint-disable-line no-console
    });
};

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case 'INIT_PIPELINE_DATA': {
      return assign({}, state, action.data);
    }
    case 'SUBMIT_PIPELINE_DATA': {
      return assign({}, state, action.data, { isRequestPending: true });
    }
    case 'SUBMIT_SUCCESSFUL': {
      return assign({}, state, action.data, { isRequestPending: false, isSuccess: true });
    }
    case 'SUBMIT_ERROR': {
      return assign({}, state, action.data, { isRequestPending: false, isSuccess: false });
    }
    default:
      return state;
  }
}
